import React from 'react';
import readyToFeast from '../../../assets/images/ReadytoFeast.PNG';
import './index.css';

const ReadyToFeast = () => {
  return (
    <div className="ready-to-feast-container text-center py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 position-relative">
            <div className="ready-to-feast-image-wrapper">
              <img
                src={readyToFeast}
                alt="Ready to Feast"
                className="img-fluid rounded-3 mt-4"
              />
              <div className="overlay-text text-white text-center mb-4">
                <h1 className="display-4 fw-bold">Ready to Feast</h1>
                <p className="lead">
                  Indulge in the royal flavors of Curry King. Place your
                  order now and enjoy an unforgettable meal.
                </p>
                {/* <ButtonComponent
                  title="Order Food"
                  onClick={handleClickNavigate}
                  backgroundColor="#000000"
                  icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadyToFeast;
